import React from 'react';
import clsx from 'clsx';
import useStyles from './Link.styles';

export type ILinkType = 'logoutLink' | 'fileDownloadLink';

interface ILinkProps {
  type: ILinkType;
  text: string;
  url: string;
  download?: string;
}

export const Link: React.FC<ILinkProps> = ({ type, text, url, download }) => {
  const classes = useStyles();

  return (
    <a
      href={url}
      className={clsx(classes[type], classes.fontRoboto)}
      download={download}
    >
      {text}
    </a>
  );
};
